import React from 'react'
import styled from 'styled-components'
import axios from 'axios';
import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ConfigProvider, Pagination } from 'antd';

const API_URL = process.env.REACT_APP_API_URL;
const Token = localStorage.getItem("JwtToken");

const Anchor = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [current, setCurrent] = useState(1);
  const [pageSize] = useState(10);
  const [allAnchors, setAllAnchors] = useState([]);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);

  const getAllAnchors = async () => {
    try {
      setLoading(true);
      const headers = {
        'Content-Type': 'application/json',
      };

      // Only add token if exists
      const token = localStorage.getItem("JwtToken");
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const [anchorsRes, agentAnchorsRes] = await Promise.all([
        axios.get(`${API_URL}/api/anchors?filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`, { headers }),
        axios.get(`${API_URL}/api/agent-anchors?filters[Payment][$eq]=Paid&populate=*&pagination[pageSize]=100`, { headers })
      ]);

      console.log('Anchors Response:', anchorsRes.data);
      console.log('Agent Anchors Response:', agentAnchorsRes.data);

      const anchorsData = anchorsRes.data.data.map(item => ({
        ...item,
        type: "anchor"
      }));

      const agentAnchorsData = agentAnchorsRes.data.data.map(item => ({
        ...item,
        type: "agent-anchor"
      }));

      const combinedAnchors = [...anchorsData, ...agentAnchorsData];
      
      console.log('Combined Anchors:', combinedAnchors);

      if (combinedAnchors.length === 0) {
        setNoData(true);
      } else {
        setNoData(false);
      }

      setAllAnchors(combinedAnchors);
    } catch (err) {
      console.error("Error fetching anchors:", err);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllAnchors();
  }, []);

  // Function to get image URL safely
  const getImageUrl = (anchor) => {
    const poster = anchor?.attributes?.Poster;
    
    if (!poster || !poster.data) {
      console.log('No poster data for:', anchor?.attributes?.Name);
      return '/placeholder-image.jpg';
    }

    // Handle single image object
    if (poster.data.attributes?.url) {
      return `${API_URL}${poster.data.attributes.url}`;
    }
    
    // Handle array of images
    if (Array.isArray(poster.data) && poster.data[0]?.attributes?.url) {
      return `${API_URL}${poster.data[0].attributes.url}`;
    }

    console.log('No valid image URL found for:', anchor?.attributes?.Name);
    return '/placeholder-image.jpg';
  };

  const filteredAnchors = allAnchors.filter(anchor => {
    if (searchQuery && !anchor.attributes.Name?.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    return true;
  });

  const currentPageAnchors = filteredAnchors.slice((current - 1) * pageSize, current * pageSize);

  const onChange = (page) => {
    setCurrent(page);
  };

  if (loading) {
    return (
      <Container>
        <div style={{ textAlign: 'center', padding: '50px', color: '#fff' }}>
          <p>Loading anchors...</p>
        </div>
      </Container>
    );
  }

  return (
    <>
      <Container>
        <Toolbar>
          <p style={{
            fontWeight: "bold",
            textTransform: "uppercase",
            marginRight: "10px",
          }}>
            Anchors
          </p>
          <SearchInput
            type="text"
            placeholder="Search anchors..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Toolbar>

        {noData ? (
          <div style={{ textAlign: 'center', padding: '50px', color: '#fff' }}>
            <p></p>
          </div>
        ) : (
          <>
            <Content1>
              {currentPageAnchors && currentPageAnchors.map((anchor) => (
                <div key={`${anchor.type}-${anchor.id}`}>
                  <Link
                    to={`/${anchor.type}/${anchor.id}`}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div className="movieTrailers-container">
                      <img 
                        src={getImageUrl(anchor)} 
                        alt={anchor?.attributes?.Name} 
                        id={anchor.id}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/placeholder-image.jpg';
                        }}
                      />
                      <div className="Movietrailers-overlay">
                        <p className="movieTrailers-title">{anchor?.attributes?.Name}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </Content1>

            <PaginationWrapper>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#e50914",
                    colorText: "#ffffff",
                    colorIcon: "#e50914",
                  },
                  components: {
                    Pagination: {
                      colorPrimary: "#e50914",
                      itemSize: "42px",
                      fontSize: "22px",
                      borderRadius: "20px",
                      colorBgTextHover: "#e50914",
                    },
                  },
                }}
              >
                <Pagination
                  className="pagination"
                  size="small"
                  current={current}
                  onChange={onChange}
                  total={filteredAnchors.length}
                  showSizeChanger={false}
                  pageSize={pageSize}
                />
              </ConfigProvider>
            </PaginationWrapper>
          </>
        )}
      </Container>
    </>
  )
}

export default Anchor;

const Container = styled.main`
  min-height: calc(10vh - 70px);
  padding: 0 calc(3.5vw + 5px);
  position: relative;
  padding-bottom: 50px;
  overflow-x: hidden;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const Content1 = styled.div`
cursor: pointer;
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(5, minmax(0, 2fr));
img{
  width: 100%;
  height: 250px;
  object-fit: cover;
  opacity: 0.9;
  &:hover{
    transform: scale(1.2);
  }
}
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    grid-gap: 10px;
    height: 100%;
    img{
      height: 150px;
    }
  }
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: space-between;
  padding: 15px;
  background-color: #101011;

  p {
    font-size: 20px;
    @media (max-width: 768px) {
      font-size: 15px;
    }
  }

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const SearchInput = styled.input`
  margin-right: 10px;
  padding: 15px;
  border: 0px inset #ff0015;
  background-color: #212529;
  border-radius: 5px;
  color: #fba010;
  float: right;
  width: 30%;
  @media (max-width: 768px) {
    width: 60%;
    padding: 10px;
  }
`;